module.exports = __webpack_public_path__ + "static/media/SFUIDisplay-Semibold.610e95e2.ttf";